import React from 'react';
import {AiFieldDefinition} from '../../../shared/fields/enrichment';
import {FieldsTable} from './FieldsTable';
import {createEnrichmentColumns} from './createEnrichmentColumns';

const columns = createEnrichmentColumns<AiFieldDefinition>();

// AI Fields table with visual grouping by agent
export const AiFieldsTable = ({
  fieldDefinitions,
}: {
  fieldDefinitions: AiFieldDefinition[];
}) => {
  return (
    <FieldsTable
      fieldDefinitions={fieldDefinitions}
      columns={columns}
      getGroupKey={(field) => field.agentId.toString()}
    />
  );
};
